export default "__VITE_ASSET___GbHYk7S__"